<template>
    <v-card
      class="mx-auto mt-6 d-flex flex-column elevation-0"
      width="300"
      variant="outlined"
    >
      <v-img
          class="image"
          width="300"
          :src="require(`@/assets/4096-2731-max.jpg`)"
          :alt="`Hormonal Contraception`"
      ></v-img>
      <div class="d-flex flex-column align-start">
        <v-card-text class="font-weight-bold py-0" style="font-size: 1.2rem;">
          Hormonelle Verhütung
        </v-card-text>
        <v-card-text class="text-justify pt-1 font-weight-medium" style="font-size: 1.1rem; line-height: 150%;">
          Wie jede hormonelle Verhütung deine Periode beeinflusst.
        </v-card-text>
      </div>
    </v-card>
  </template>
  
  <script>
    export default {
      name:"HormonalContraception"
    }
  </script>
  
  <style>
  .image{
    margin-bottom: 16px !important;
    height: 170px;
  }
  .image img{
    object-fit: cover;
    height: 170px;
  }
  </style>
  
  